import { StatsBar } from "@/components/ui/StatsBar";
import { Star } from "@/components/ui/Star";
import { landingContent } from "@/content/landing";

interface StatsSectionProps {
  className?: string;
}

export function StatsSection({ className = "" }: StatsSectionProps) {
  const stats = landingContent.stats;

  return (
    <StatsBar
      id="stats"
      className={className}
      items={[
        { value: "85 000", accent: "+", label: stats.users },
        { value: "500 000", accent: "+", label: stats.hours },
        {
          value: "4.9",
          icon: <Star active />,
          label: stats.rating,
        },
        { value: "8", accent: "×", label: stats.speed },
      ]}
    />
  );
}
